module.exports = __webpack_public_path__ + "static/media/spa.8d0965dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/spa.svg
// module id = 1539
// module chunks = 0